// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-back-img {\n\twidth: 20px;\n\theight: 20px;\n\tposition: absolute;\n\ttop: 4px;\n\tleft: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
